import theme from '../../muiTheme';

const styles = {

    rootForm: {
        marginLeft: '30px',
        borderRadius: '20px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
        alignSelf: 'flex-start',
        boxSizing: 'border-box',
        background: theme.palette.faint,
    },
    mainContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        background: theme.palette.faint, 
        borderRadius: '20px',
        padding: '5px 10px',
        paddingLeft: '5px',
        //transition: '0.5s',
        boxSizing: 'border-box',
        width: '100%'
    },
    navSearchBar: {
        background: 'transparent', 
        borderRadius: '15px',
        border: '0px solid transparent',
        height: '40px',
        padding: '0px 20px',
        fontSize: '16px',
        marginRight: '5px',
        color: theme.palette.gray,
        '&:focus': { //not being picked up ?????
            outline: 'none',
        },
        '&:focusVisible': { //not being picked up ?????
            outline: 'none',
        }
    },
    searchButton: {
        borderRadius: '20px',
        background: theme.palette.primary.main,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '10px',
        transition: '0.2s',
        cursor: 'pointer', 
        border: '0px solid transparent',
        '&:hover': { //not being picked up ?????
            padding: '15px'
        }
    },
    filterSearchButton: {
        borderRadius: '20px',
        background: theme.palette.primary.main,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-evenly',
        alignItems: 'center',
        padding: '10px 20px',
        transition: '0s',
        marginTop: '30px',
        marginBottom: '10px',
        cursor: 'pointer', 
        border: '0px solid transparent',
        '&:hover': { //not being picked up ?????
            padding: '15px'
        }
    },
    filterSpan: {
        color: 'white',
        fontSize: '15px',
        marginLeft: '5px'
    },
    navSearchIcon: {
        color: 'white'
    },
    tagFilter: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '10px',
        marginLeft: '4px',
        borderRadius: '20px',
        border: '0px solid transparent',
        background: theme.palette.lightGray,
        cursor: 'pointer'
    },
    tagFilterIcon: {
        color: 'white'
    },
    horizDivider: {
        height: '30px', 
        marginLeft: '10px',
        width: '2px',
        background: theme.palette.lightGray
    },
    tagBarContainer: {
        position: 'relative',
        background: theme.palette.faint,
        width: '100%', 
        borderRadius: '20px',
        transition: '0.3s',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-evenly',
        alignItems: 'center',
        boxSizing: 'border-box'
    },
    chipInput: {
        width: '200px'
    }


}

export default styles; 